import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { ModalDesktop as Modal } from '@alfa-bank/site-modal/desktop';
import { Link } from '@alfa-bank/site-link';
import { useNamedContainers } from '@alfa-bank/site-named-container/utils';

import { X5BankAgreementContainer as Component } from './x5-bank-agreement-container';
import type { TX5AgreementContainer, IDeps } from './models';

export const X5BankAgreementContainerDesktop = createWidget<IDeps, TX5AgreementContainer>({
    Link,
    Modal,
    useNamedContainers,
})(Component);
